import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useTranslation } from 'react-i18next';
import { useDocImage } from '../hooks/useDocImage';

export default function LeadErasureRules() {
  const { t } = useTranslation();
  const image001 = useDocImage('lead-erasure-img', 'image001.png');
  const image002 = useDocImage('lead-erasure-img', 'image002.png');
  const image003 = useDocImage('lead-erasure-img', 'image003.png');
  const image004 = useDocImage('lead-erasure-img', 'image004.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.leadErasure.title')}</h1>
            <p className="header-para">{t('documentation.leadErasure.intro')}</p>
            <img src={image002} alt={t('documentation.leadErasure.overview.imageAlt')} className="img-fluid pt-10 pb-30" />

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.accessing.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.leadErasure.accessing.steps.step1') }}></li>
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: t('documentation.leadErasure.accessing.steps.step2') }}></span>
                    <img src={image001} alt={t('documentation.leadErasure.accessing.imageAlt')} className="doc-img-native pb-10 pt-10" />
                  </li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.leadErasure.accessing.steps.step3') }}></li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.overview.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.leadErasure.overview.desc')}</p>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.rulesTable.title')}
              </div>
              <div className="card-body">
                <img src={image004} alt={t('documentation.leadErasure.rulesTable.imageAlt')} className="img-fluid pt-10 pb-20" />
                <ul>
                  <li>{t('documentation.leadErasure.rulesTable.items.columns')}</li>
                  <li>{t('documentation.leadErasure.rulesTable.items.pagination')}</li>
                  <li>{t('documentation.leadErasure.rulesTable.items.empty')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.ruleTypes.title')}
              </div>
              <div className="card-body">
                <p><b>{t('documentation.leadErasure.ruleTypes.fieldMatch.title')}</b></p>
                <p>{t('documentation.leadErasure.ruleTypes.fieldMatch.desc')}</p>
                <p className="mt-3"><b>{t('documentation.leadErasure.ruleTypes.duplicate.title')}</b></p>
                <p>{t('documentation.leadErasure.ruleTypes.duplicate.desc')}</p>
                <p className="mt-3"><b>{t('documentation.leadErasure.ruleTypes.utmMatch.title')}</b></p>
                <p>{t('documentation.leadErasure.ruleTypes.utmMatch.desc')}</p>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.operators.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.leadErasure.operators.fieldMatch')}</p>
                <p className="mt-2">{t('documentation.leadErasure.operators.utmMatch')}</p>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.regexPresets.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li>{t('documentation.leadErasure.regexPresets.items.letters')}</li>
                  <li>{t('documentation.leadErasure.regexPresets.items.digits')}</li>
                  <li>{t('documentation.leadErasure.regexPresets.items.exactly9')}</li>
                  <li>{t('documentation.leadErasure.regexPresets.items.nineSame')}</li>
                  <li>{t('documentation.leadErasure.regexPresets.items.eightPlus')}</li>
                  <li>{t('documentation.leadErasure.regexPresets.items.custom')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.addEdit.title')}
              </div>
              <div className="card-body">
                <img src={image003} alt={t('documentation.leadErasure.addEdit.imageAlt')} className="img-fluid pt-10 pb-20" />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.leadErasure.addEdit.items.step1') }}></li>
                  <li>{t('documentation.leadErasure.addEdit.items.step2')}</li>
                  <li>{t('documentation.leadErasure.addEdit.items.step3')}</li>
                  <li>{t('documentation.leadErasure.addEdit.items.step4')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.toggleStatus.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.leadErasure.toggleStatus.desc')}</p>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.leadErasure.deleteRule.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.leadErasure.deleteRule.desc')}</p>
              </div>
            </div>

            <p className="alert alert-info mb-0">{t('documentation.leadErasure.permissionsNote')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
